import AddAccessRight from '../AccessRight/AddAccessRight';
import { SERVER_URI, TEST_URI } from '../Constant/server';
import { apiGet, apiPost } from '../utils/axios';

const BIND_ACCESS_RIGHT = `${SERVER_URI}/permission/get-all-modules`;
const ADD_ACCESS_RIGHT = `${SERVER_URI}/permission/add`;
const GET_ACCESS_RIGHT = `${SERVER_URI}/permission/employee-permissiondata`;
const EMPLOYEE_ACCESS_RIGHT = `${SERVER_URI}/permission/add-employee-permission`;


export default {
  Bind_Access_Right: async function () {
    return apiGet(BIND_ACCESS_RIGHT);
  },
  create_Access_Right: async function (payload) {
   // console.log("payload..",payload)
    return apiPost(ADD_ACCESS_RIGHT, payload);
  },
  get_Employee_Access_Right: async function (payload) {
    return apiPost(GET_ACCESS_RIGHT, payload);
  },
  employee_Access_Right: async function (paylaod) {
    return apiPost(EMPLOYEE_ACCESS_RIGHT, paylaod);
  }

};
